import { Banner, Button, ArrowRightIcon } from '@ag1/ui';
import { GAEventName } from 'analytics/ga-event-name.enum';
import { sendAnalytics } from 'analytics/send-analytics';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import usePageId from 'shared/hooks/usePageId';

import styles from './ConnectPaymentMethodBannerV2.module.scss';

export const ConnectPaymentMethodBannerV2 = ({
  onActionClick,
  isMissingPayment
}: {
  isMissingPayment: boolean;
  onActionClick: () => void;
}) => {
  const contractId = usePageId();
  const { t } = useTranslation('banners');

  const onClick = useCallback(() => {
    if (onActionClick) onActionClick();

    sendAnalytics({
      event: GAEventName.BUTTON_CLICK,
      click_text: 'Add Now',
      location: 'Missing payment method CTA',
      click_url: `/members/subscriptions/${contractId}`
    });
  }, [onActionClick, contractId]);

  if (!isMissingPayment) {
    return null;
  }

  return (
    <Banner
      className={styles.banner}
      variant="warning"
      label={t('paymentMethod.title')}
      text={t('paymentMethod.description')}>
      <Button
        size="small"
        icon={<ArrowRightIcon />}
        iconPosition="right"
        theme="new"
        onClick={onClick}
        rounded>
        {t('paymentMethod.addCtaBtnLabel')}
      </Button>
    </Banner>
  );
};
